import request from "utils/request";

export async function getCampaigns() {
	return request("/rest/campaigns");
}

export async function createCampaign(payload) {
	return request("/rest/campaigns", {
		method: "PUT",
		body: payload
	});
}

export async function renameCampaign(payload) {
	return request("/rest/campaigns", {
		method: "POST",
		body: payload
	});
}

export async function deleteCampaigns(ids) {
	// console.log(ids);
	return request("/rest/delete/campaigns", {
		method: "POST",
		body: ids
	});
}

export async function getCampaign(campaignId) {
	return request("/rest/campaign/" + campaignId);
}

export async function resumeCampaign(campaignId) {
	return request("/action/resume/campaign/" + campaignId);	
}

export async function pauseCampaign(campaignId) {
	return request("/action/pause/campaign/" + campaignId);	
}